export const GET_CHECK_PASSWORD_API_CALL = 'GET_CHECK_PASSWORD_API_CALL'
export const SAVE_CHECK_PASSWORD_DATA = 'SAVE_CHECK_PASSWORD_DATA'
